<div class="o-flex__item u-flex-1/1@desktop u-flex-1/1@tablet u-flex-1/1@small o-flex o-flex--centered  text-center mt-5" xmlns="http://www.w3.org/1999/html">
  <i class="c-icon c-icon--24_2 u-icon--extra-big u-margin-horizontal-tiny text-light-color"></i>
</div>
<div class="b-card mt-3">
  <div class="text mb-0 d-flex ">
    <span class="pl-2 text-card-button text-center">Wystąpił błąd.<br>Twoja szkoda jest już zgłoszona{{!!numerSzkody ? ' pod numerem ' + numerSzkody : ''}}.</span>
  </div>
</div>
